import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { mapGetters, mapMutations } from "vuex";

import * as types from "@recipient/store/types";

@Component({
	name: "department-item",
	computed: {
		...mapGetters({
			selectedItems: types.RECIPIENT_USER_SELECT,
		}),
	},
	methods: {
		...mapMutations({
			toggleDeptSelection: types.RECIPIENT_DEPT_TOGGLE,
		}),
	},
})
export default class DepartmentItem extends Vue {
	//
	// ────────────────────────────────────────────────── I ──────────
	//   :::::: P R O P S : :  :   :    :     :        :          :
	// ────────────────────────────────────────────────────────────
	//

	@Prop({ type: Object }) item!: recipient.Department;

	//
	// ────────────────────────────────────────────────────── I ──────────
	//   :::::: G E T T E R S : :  :   :    :     :        :          :
	// ────────────────────────────────────────────────────────────────
	//

	selectedItems!: {
		[key: string]: recipient.OrgPerson | recipient.Department;
	};

	//
	// ────────────────────────────────────────────────────────── I ──────────
	//   :::::: M U T A T I O N S : :  :   :    :     :        :          :
	// ────────────────────────────────────────────────────────────────────
	//

	toggleDeptSelection!: (dept: recipient.Department) => void;

	//
	// ──────────────────────────────────────────────────────── I ──────────
	//   :::::: C O M P U T E D : :  :   :    :     :        :          :
	// ──────────────────────────────────────────────────────────────────
	//

	get isSelected() {
		const { deptCode } = this.item as any;
		return deptCode in this.selectedItems;
	}

	//
	// ────────────────────────────────────────────────────── I ──────────
	//   :::::: M E T H O D S : :  :   :    :     :        :          :
	// ────────────────────────────────────────────────────────────────
	//

	select(event: MouseEvent, item: recipient.Department) {
		this.toggleDeptSelection(item);
	}
}
